module.exports = __webpack_public_path__ + "img/login_bg.73d59517.png";